import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private counter = 0;
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);
  private readonly messageSubject = new BehaviorSubject<string | null>(null);
  readonly loading$: Observable<boolean> = this.loadingSubject.asObservable();
  readonly message$: Observable<string | null> = this.messageSubject.asObservable();

  constructor(private ngZone: NgZone) {}

  private runInZone(task: () => void): void {
    if (NgZone.isInAngularZone()) {
      task();
      return;
    }
    this.ngZone.run(task);
  }

  show(message?: string): void {
    this.runInZone(() => {
      this.counter += 1;
      if (message !== undefined) {
        const nextMessage = message && message.trim() ? message : null;
        this.messageSubject.next(nextMessage);
      } else if (!this.messageSubject.value) {
        this.messageSubject.next(null);
      }
      if (!this.loadingSubject.value) {
        this.loadingSubject.next(true);
      }
    });
  }

  hide(): void {
    this.runInZone(() => {
      if (this.counter > 0) {
        this.counter -= 1;
      }
      if (this.counter === 0 && this.loadingSubject.value) {
        this.loadingSubject.next(false);
        this.messageSubject.next(null);
      }
    });
  }

  reset(): void {
    this.runInZone(() => {
      this.counter = 0;
      this.loadingSubject.next(false);
      this.messageSubject.next(null);
    });
  }
}
